module.exports = __webpack_public_path__ + "static/media/cafetiere.39c28b56.png";